module.exports = __webpack_public_path__ + "assets/img/home_ex_1.84e83d3e.png";